import IconApps from '@material-ui/icons/Apps';

import {
  SOCIAL_CHANNEL,
  NATIVE_CHANNEL,
  WEBSITE_CHANNEL,
  EMAILS_CHANNEL,
  PLATFORM_CHANNEL,
} from 'src/data/channel';
import {
  REVIEWS_CHANNELS,
  RESOURCE_DOCUMENT,
  isEmailCsvResourceDocument,
} from 'src/data/performance';
import IconPlatformFacebook from 'src/assets/icons/PlatformFacebook';
import IconChannelFacebook from 'src/assets/icons/ChannelFacebook';
import IconPlatformLinkedin from 'src/assets/icons/PlatformLinkedin';
import IconPlatformYoutube from 'src/assets/icons/PlatformYoutube';
import IconChannelTwitter from 'src/assets/icons/ChannelTwitter';
import IconChannelInstagram from 'src/assets/icons/ChannelInstagram';
import IconChannelGoogle from 'src/assets/icons/ChannelGoogle';
import IconChannelTaboola from 'src/assets/icons/ChannelTaboola';
import IconChannelOutbrain from 'src/assets/icons/ChannelOutbrain';
import IconChannelRevcontent from 'src/assets/icons/ChannelRevcontent';
import IconChannelVerizon from 'src/assets/icons/ChannelVerizon';
import { ChannelPinterest } from 'src/assets/icons/ChannelPinterest';
import { NewChannelLinkedin } from 'src/assets/icons/NewChannelLinkedin';
import { MetaIcon } from 'src/assets/icons/ChannelMeta';
import { ChannelLandingPagesIcon } from 'src/assets/icons/ChannelLandingPages';
import { ChannelHomepageIcon } from 'src/assets/icons/ChannelHomepage';
import { ChannelHubspotIcon } from 'src/assets/icons/ChannelHubspot';
import { ChannelThoughtLeadershipIcon } from 'src/assets/icons/ChannelThoughtLeadership';
import { ChannelCompetitorsIcon } from 'src/assets/icons/ChannelCompetitors';
import { ChannelFacebookPages } from 'src/assets/icons/ChannelFacebookPages';
import { ChannelReviewIcon } from 'src/assets/icons/ChannelReview';
import { ChannelProductPageIcon } from 'src/assets/icons/ChannelProductPage';
import { ChannelOtherIcon } from 'src/assets/icons/ChannelOther';
import { IconEmail } from 'src/assets/icons/IconEmail';
import { IconDocument } from 'src/assets/icons/IconDocument';
import { IconChannelWTM } from 'src/assets/icons/channels/IconChannelWTM';

export function pickChannelIcon(channel, rounded, meta) {
  if (channel === SOCIAL_CHANNEL.facebook) {
    return meta ? MetaIcon : rounded ? IconChannelFacebook : IconPlatformFacebook;
  }
  if (channel === SOCIAL_CHANNEL.instagram) {
    return IconChannelInstagram;
  }
  if (channel === SOCIAL_CHANNEL.linkedin) {
    return rounded || meta ? NewChannelLinkedin : IconPlatformLinkedin;
  }
  if (channel === SOCIAL_CHANNEL.twitter) {
    return IconChannelTwitter;
  }
  if (channel === SOCIAL_CHANNEL.google) {
    return IconChannelGoogle;
  }
  if (channel === SOCIAL_CHANNEL.youtube) {
    return IconPlatformYoutube;
  }
  if (channel === SOCIAL_CHANNEL.pinterest) {
    return ChannelPinterest;
  }

  if (channel === NATIVE_CHANNEL.taboola) {
    return IconChannelTaboola;
  }
  if (channel === NATIVE_CHANNEL.outbrain) {
    return IconChannelOutbrain;
  }
  if (channel === NATIVE_CHANNEL.revcontent) {
    return IconChannelRevcontent;
  }
  if (channel === NATIVE_CHANNEL.verizon) {
    return IconChannelVerizon;
  }
  if (REVIEWS_CHANNELS.includes(channel)) {
    return ChannelReviewIcon;
  }
  if (channel === WEBSITE_CHANNEL.homepage) {
    return ChannelHomepageIcon;
  }
  if (channel === WEBSITE_CHANNEL.landingPage) {
    return ChannelLandingPagesIcon;
  }
  if (channel === WEBSITE_CHANNEL.competitors) {
    return ChannelCompetitorsIcon;
  }
  if (channel === WEBSITE_CHANNEL.thoughtLeadership) {
    return ChannelThoughtLeadershipIcon;
  }
  if (channel === WEBSITE_CHANNEL.productPage) {
    return ChannelProductPageIcon;
  }
  if (channel === WEBSITE_CHANNEL.other) {
    return ChannelOtherIcon;
  }
  if (channel === EMAILS_CHANNEL.hubspot) {
    return ChannelHubspotIcon;
  }
  if (channel === SOCIAL_CHANNEL.facebookPages) {
    return ChannelFacebookPages;
  }

  if (isEmailCsvResourceDocument(channel) || channel === RESOURCE_DOCUMENT.emailCsvResource) {
    return IconEmail;
  }
  if (channel === RESOURCE_DOCUMENT.googleDocs) {
    return IconDocument;
  }

  if (channel === PLATFORM_CHANNEL.projectWtm) {
    return IconChannelWTM;
  }

  return IconApps;
}
